// extracted by mini-css-extract-plugin
export default {"app":"App_app__Uljzd","h1":"App_h1__SPL0H"};